var _g, _polygon, _g2, _path, _g3, _g4, _g5, _path2, _path3, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExistingcontracts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.756,
    y: 106.135,
    style: {
      fill: "#F5F5F5"
    },
    width: 256.027,
    height: 211.404
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.756,
    y: 110.617,
    style: {
      fill: "#FAFAFA"
    },
    width: 251.918,
    height: 202.618
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "370.815,255.593 370.815,184.006 363.377,184.006 363.377,174.551 346.642,166.723  346.642,157.045 343.853,157.045 343.853,184.006 341.064,184.006 341.064,255.593 337.345,255.593 337.345,218.405  328.978,218.405 328.978,198.881 326.189,198.881 326.189,255.593 319.681,255.593 319.681,234.21 315.033,234.21  315.033,228.632 304.806,228.632 304.806,209.108 299.228,209.108 299.228,196.092 292.72,196.092 292.72,176.568  289.931,176.568 289.931,196.092 283.423,196.092 283.423,209.108 277.845,209.108 277.845,228.632 267.618,228.632  267.618,234.21 262.969,234.21 262.969,255.593 257.391,255.593 257.391,228.632 247.164,228.632 247.164,169.131  244.375,169.131 244.375,162.623 222.063,162.623 222.063,169.131 217.414,169.131 217.414,211.897 198.82,211.897  198.82,216.546 192.312,216.546 192.312,219.335 198.82,219.335 198.82,236.069 179.296,236.069 179.296,180.287  175.577,180.287 175.577,169.131 166.28,169.131 166.28,126.365 163.491,126.365 163.491,169.131 156.983,169.131  156.983,180.287 120.756,180.287 120.756,313.235 372.674,313.235 372.674,255.593  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 227.363,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.114,
    y: 231.779,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 218.531,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 227.363,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.298,
    y: 231.779,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 218.531,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 222.947,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.481,
    y: 231.779,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.665,
    y: 249.443,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 240.611,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 245.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 249.443,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 253.859,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.848,
    y: 271.524,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 218.531,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 222.947,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 236.195,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 240.611,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 245.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 249.443,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 253.859,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.032,
    y: 271.524,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 218.531,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 222.947,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 227.363,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 231.779,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 236.195,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 240.611,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 245.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 249.443,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 253.859,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.216,
    y: 258.276,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 218.531,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 222.947,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 236.195,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 240.611,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 245.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 249.443,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 183.202,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 187.618,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 192.034,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 196.451,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 200.867,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 205.283,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 209.699,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 214.115,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 218.531,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 222.947,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 236.195,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 240.611,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.583,
    y: 245.027,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 171.736,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 176.152,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 180.568,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 198.232,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.688,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 171.736,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 176.152,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 180.568,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 198.232,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.872,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 171.736,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 176.152,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 180.568,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 198.232,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.055,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 171.736,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 176.152,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 180.568,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 207.065,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.239,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 171.736,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 176.152,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 180.568,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 207.065,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 211.481,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.423,
    y: 260.057,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 171.736,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 176.152,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 180.568,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 207.065,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 211.481,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 260.057,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.606,
    y: 264.474,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.569,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.753,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.936,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.12,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 274.623,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.304,
    y: 279.039,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 274.623,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 279.039,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.487,
    y: 283.455,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 186.301,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 190.717,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 195.133,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 199.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 203.966,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 208.382,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 265.791,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 270.207,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 274.623,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 279.039,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.338,
    y: 283.455,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 186.301,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 190.717,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 195.133,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 199.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 203.966,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 208.382,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.522,
    y: 265.791,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 186.301,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 190.717,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 195.133,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 199.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 203.966,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 208.382,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.705,
    y: 265.791,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 186.301,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 190.717,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 195.133,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 199.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 203.966,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 208.382,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.889,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 186.301,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 190.717,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 195.133,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 199.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 203.966,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 208.382,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.073,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 186.301,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 190.717,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 195.133,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 199.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 203.966,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 208.382,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 212.798,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 217.214,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.256,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 198.232,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 207.065,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 211.481,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 255.641,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 264.474,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 268.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 273.306,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 277.722,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.055,
    y: 282.138,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 198.232,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 207.065,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 211.481,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 277.722,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.239,
    y: 282.138,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 184.984,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 189.4,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 193.816,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 198.232,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 202.648,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 207.065,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 211.481,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 260.057,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 264.474,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 268.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 273.306,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.422,
    y: 282.138,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 255.641,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 260.057,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 264.474,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 268.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 277.722,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 282.138,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 286.554,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 290.97,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 299.802,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 304.218,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.404,
    y: 308.634,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 255.641,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 260.057,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 264.474,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 268.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 282.138,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 286.554,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 295.386,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 299.802,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 304.218,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.587,
    y: 308.634,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 215.897,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 220.313,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 224.729,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 229.145,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 233.561,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 237.977,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 242.393,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 246.809,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 251.225,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 255.641,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 260.057,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 264.474,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 268.89,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 273.306,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 282.138,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 290.97,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 295.386,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 299.802,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 304.218,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.771,
    y: 308.634,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 241.076,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 245.492,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 249.908,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 254.324,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 258.741,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 263.157,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 276.405,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 280.821,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 285.237,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 289.653,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 294.069,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 298.485,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.359,
    y: 302.901,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 241.076,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 245.492,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 249.908,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 254.324,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 258.741,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 263.157,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 276.405,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 280.821,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 285.237,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 289.653,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 294.069,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 298.485,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.543,
    y: 307.317,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 265.791,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 274.623,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 279.039,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 283.455,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 287.871,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 292.287,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 296.703,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 301.119,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.533,
    y: 305.535,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 221.63,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 226.046,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 230.462,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 234.878,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 239.294,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 243.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 248.126,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 252.542,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 256.959,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 261.375,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 265.791,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 270.207,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 274.623,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 279.039,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 283.455,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 287.871,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 292.287,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 296.703,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 301.119,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.717,
    y: 305.535,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 238.829,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 243.245,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 247.662,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 252.078,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 256.494,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 260.91,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 265.326,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 269.742,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 274.158,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.925,
    y: 278.574,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 238.829,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 243.245,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 247.662,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 252.078,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 256.494,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 260.91,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 265.326,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 269.742,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.109,
    y: 274.158,
    style: {
      fill: "#F5F5F5"
    },
    width: 2.634,
    height: 2.634
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.215,
    y: 106.625,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.422,
    height: 210.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.047,
    y: 106.625,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.422,
    height: 210.914
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.879,
    y: 106.625,
    style: {
      fill: "#F5F5F5"
    },
    width: 4.422,
    height: 210.914
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M237.597,290.558h-13.484v-0.898c0-1.762,1.974-3.163,4.322-3.068l5.282,0.214 c2.176,0.088,3.88,1.435,3.88,3.068V290.558z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M205.662,266.106c-0.045-0.932-0.813-1.664-1.746-1.664h-11.954 c-0.933,0-1.701,0.732-1.746,1.664l2.838,24.911h17.842L205.662,266.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M238.128,227.806h-4.454l-5.006,47.049h4.454c0.738,0,1.4-0.598,1.479-1.336l4.722-44.376 C239.4,228.404,238.866,227.806,238.128,227.806z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M231.238,274.855h-66.755c-0.738,0-1.273-0.598-1.194-1.336l4.722-44.376 c0.078-0.738,0.74-1.337,1.479-1.337h66.755c0.738,0,1.273,0.598,1.194,1.337l-4.722,44.376 C232.638,274.257,231.976,274.855,231.238,274.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M229.991,270.509h-62.95c-0.644,0-1.111-0.522-1.042-1.166l4.12-38.717 c0.068-0.644,0.646-1.166,1.29-1.166h62.95c0.644,0,1.11,0.522,1.042,1.166l-4.119,38.717 C231.213,269.987,230.635,270.509,229.991,270.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M211.574,289.083h-21.961c-0.53,0-0.959,0.429-0.959,0.959v0.017 c0,0.53,0.429,0.959,0.959,0.959h21.961c0.53,0,0.959-0.429,0.959-0.959v-0.017 C212.533,289.512,212.103,289.083,211.574,289.083z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211.268,
    y: 290.458,
    style: {
      fill: "#E6E6E6"
    },
    width: 54.346,
    height: 8.199
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M114.178,382.023h-1.356c-0.168,0-0.308-0.137-0.312-0.307l-2.145-83.06l6.27,0l-2.144,83.06 C114.486,381.887,114.347,382.023,114.178,382.023z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "65.809,382.023 62.674,382.023 71.521,298.656 77.79,298.656  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "267.734,382.023 267.734,382.023 255.719,298.656 261.989,298.656 270.835,382.023  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.896,
    y: 290.458,
    style: {
      fill: "#F5F5F5"
    },
    width: 158.873,
    height: 8.199
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "221.812,382.023 218.21,382.023 218.208,382.021 216.875,298.656 223.144,298.656  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M171.059,288.984h-1.665c-0.175,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C171.42,288.786,171.268,288.984,171.059,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M173.36,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C173.721,288.786,173.568,288.984,173.36,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M175.66,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C176.021,288.786,175.869,288.984,175.66,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M177.961,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C178.322,288.786,178.17,288.984,177.961,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M180.262,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C180.622,288.786,180.47,288.984,180.262,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M182.562,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C182.923,288.786,182.771,288.984,182.562,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M184.863,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C185.224,288.786,185.072,288.984,184.863,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.163,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C187.524,288.786,187.372,288.984,187.163,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M189.464,288.984h-1.665c-0.175,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C189.825,288.786,189.673,288.984,189.464,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M191.765,288.984H190.1c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C192.126,288.786,191.973,288.984,191.765,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M194.065,288.984H192.4c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C194.426,288.786,194.274,288.984,194.065,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M196.366,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C196.727,288.786,196.575,288.984,196.366,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M198.666,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C199.027,288.786,198.875,288.984,198.666,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M200.967,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.469,1.76 C201.328,288.786,201.176,288.984,200.967,288.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M203.268,288.984h-1.665c-0.176,0-0.318-0.142-0.318-0.318v-1.761 c0-0.176,0.142-0.318,0.318-0.318h1.195c0.144,0,0.27,0.097,0.307,0.236l0.47,1.76 C203.628,288.786,203.476,288.984,203.268,288.984z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.72,
    y: 287.786,
    style: {
      fill: "#EBEBEB"
    },
    width: 37.222,
    height: 2.772
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M139.193,306.153H81.632c-2.761,0-5,2.239-5,5v3.783h67.561v-3.783 C144.193,308.392,141.955,306.153,139.193,306.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M78.833,364.937l21.648-2.128v-30.424h8.58v30.415l21.735,2.136 c2.158,0.212,3.803,2.026,3.803,4.194v3.251H105.61h-1.59H75.031v-3.251C75.031,366.963,76.676,365.149,78.833,364.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M126.699,376.414c0,3.098,2.511,5.609,5.609,5.609c3.098,0,5.609-2.511,5.609-5.609 c0-3.098-2.511-5.609-5.609-5.609C129.21,370.805,126.699,373.316,126.699,376.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M82.931,376.414c0,3.098-2.511,5.609-5.609,5.609c-3.098,0-5.609-2.511-5.609-5.609 c0-3.098,2.511-5.609,5.609-5.609C80.42,370.805,82.931,373.316,82.931,376.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M103.137,338.925h3.268c2.283,0,4.133-1.85,4.133-4.133v-22.965H99.004v22.965 C99.004,337.074,100.855,338.925,103.137,338.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M116.172,306.719c-2.993-11.32-9.733-40.605-11.153-79.295 c-0.219-5.979-5.152-10.704-11.134-10.704H73.913c-6.135,0-11.119,4.952-11.145,11.086c-0.078,18.194,1.193,55.388,11.455,85.619 l38.012-1.4C114.947,311.925,116.865,309.342,116.172,306.719z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M110.796,311.398c0,0-10.255-36.482-11.949-82.678c-0.202-5.515-4.752-9.874-10.271-9.874H70.154 c-5.659,0-10.256,4.567-10.28,10.226c-0.072,16.782,1.101,54.439,10.567,82.326H110.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M102.894,284.876c0,0,21.891-4.428,43.026-2.284c21.134,2.144-9.944,29.761-9.944,29.761h-4.363 c0,0,16.469-17.51,15.551-21.87c-0.917-4.359-42.393,1.387-42.393,1.387L102.894,284.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M70.443,311.398h35.846c0,0-10.256-36.485-11.954-82.677c-0.203-5.515-4.748-9.873-10.271-9.873 H70.158c-5.665,0-10.256,4.568-10.286,10.226C59.804,245.852,60.976,283.509,70.443,311.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M144.591,310.545H71.727c-1.111,0-2.011,0.9-2.011,2.011v0.369c0,1.111,0.9,2.011,2.011,2.011 h72.864c1.111,0,2.011-0.901,2.011-2.011v-0.369C146.603,311.445,145.702,310.545,144.591,310.545z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M416.505,345.409c0.013-0.396,1.344-39.676,7.733-45.889c6.214-6.041,13.347-0.225,13.647,0.025 l0.641-0.767c-0.081-0.068-8.13-6.639-14.984,0.025c-6.676,6.492-7.982,44.94-8.035,46.574L416.505,345.409z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M415.957,353.129c0.046-0.47,4.367-47.156-12.683-66.724l-0.754,0.656 c16.767,19.243,12.487,65.505,12.442,65.97L415.957,353.129z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M416.587,348.19l0.998-0.066c-0.035-0.529-3.337-53.076,9.169-64.579l-0.677-0.736 C413.221,294.635,416.444,346.009,416.587,348.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M414.959,348.161l1-0.008c-0.012-1.447-0.413-35.493-10.084-41.035 c-2.15-1.233-4.255-1.439-6.257-0.61c-5.848,2.419-8.746,12.826-8.866,13.267l0.965,0.264 c0.028-0.103,2.89-10.377,8.285-12.607c1.701-0.702,3.509-0.517,5.377,0.554C414.556,313.244,414.957,347.813,414.959,348.161z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M418.725,348.186l0.998-0.057c-0.015-0.269-1.459-26.904,5.729-36.289 c1.742-2.273,3.632-3.357,5.63-3.218c4.71,0.329,8.66,7.222,8.699,7.291l0.871-0.492c-0.171-0.303-4.252-7.429-9.499-7.796 c-2.347-0.167-4.535,1.049-6.495,3.608C417.245,320.911,418.662,347.077,418.725,348.186z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M417.149,351.809c0.196-2.584,4.699-63.402-3.225-74.119l-0.804,0.594 c7.705,10.421,3.079,72.82,3.031,73.449L417.149,351.809z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M397.464,312.672c0,0,4.753,1.752,3.34,5.89c-1.413,4.137-16.445,10.946-16.445,10.946 s-6.295-5.77-0.514-15.154C389.627,304.969,397.335,309.711,397.464,312.672z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M418.129,304.796c0,0-5.062-0.212-5.35,4.151c-0.288,4.362,10.966,16.432,10.966,16.432 s8.031-2.903,6.306-13.79C428.326,300.702,419.387,302.113,418.129,304.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M422.414,283.913c0,0-3.375-0.362-3.103-2.418s13.119-7.346,20.699,1.209 c0,0-4.854,8.337-11.87,8.446C421.124,291.259,422.414,283.913,422.414,283.913z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M416.125,278.922c0,0,3.056,1.477,3.912-0.411c0.857-1.888-7.249-13.173-18.207-9.922 c0,0-0.29,9.643,5.607,13.446C413.335,285.838,416.125,278.922,416.125,278.922z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M432.104,311.009c0,0-2.329-1.881,0.184-2.799c2.514-0.918,14.847-0.657,14.976,11.56 c0,0-14.365,2.387-16.143-2.267C429.343,312.85,432.104,311.009,432.104,311.009z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M402.812,283.607c0,0,2.329-1.881-0.184-2.798c-2.514-0.918-14.847-0.657-14.976,11.56 c0,0,14.365,2.387,16.143-2.266C405.573,285.448,402.812,283.607,402.812,283.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M410.406,293.449c0,0,0.205-2.286-1.641-1.39c-1.846,0.896-8.275,7.833-1.61,14.415 c0,0,8.972-6.645,7.354-10.105C412.892,292.909,410.406,293.449,410.406,293.449z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M434.186,296.706c0,0-1.392-1.825,0.647-2.051c2.039-0.226,11.177,2.213,9.049,11.335 c0,0-11.133-0.837-11.61-4.626C431.795,297.575,434.186,296.706,434.186,296.706z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "396.575,382.023 434.773,382.023 438.894,340.202 392.454,340.202  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.415,
    y: 335.588,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 831.3483 680.404)",
    style: {
      fill: "#E6E6E6"
    },
    width: 50.519,
    height: 9.228
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M73.518,135.347c40.994-57.354,122.646-39.623,155.833,1.204 c33.187,40.828,88.883-32.599,136.548-42.864c47.664-10.264,103.639-0.612,72.764,125.71 C407.788,345.72,310.899,383.542,210.182,356.087C109.464,328.632,21.211,208.529,73.518,135.347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M73.518,135.347c40.994-57.354,122.646-39.623,155.833,1.204 c33.187,40.828,88.883-32.599,136.548-42.864c47.664-10.264,103.639-0.612,72.764,125.71 C407.788,345.72,310.899,383.542,210.182,356.087C109.464,328.632,21.211,208.529,73.518,135.347z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sheet"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M403.287,418.427h-168.24c-3.193,0-5.521-2.588-5.199-5.781l28.869-286.418 c0.322-3.193,3.171-5.781,6.365-5.781h168.24c3.193,0,5.521,2.588,5.199,5.781l-28.869,286.418 C409.33,415.838,406.48,418.427,403.287,418.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M378.096,142.147h-62.165c-2.564,0-4.433-2.078-4.175-4.642l1.736-17.227 c0.046-0.459,0.456-0.831,0.915-0.831h69.788c0.459,0,0.794,0.372,0.748,0.831l-1.736,17.227 C382.948,140.069,380.66,142.147,378.096,142.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.095,111.571c-2.567,0-4.858,2.081-5.117,4.647l-0.728,7.218h9.297l0.728-7.218 C354.534,113.652,352.662,111.571,350.095,111.571z M349.398,118.493c-1.038,0-1.794-0.841-1.69-1.879 c0.105-1.038,1.031-1.879,2.069-1.879c1.038,0,1.794,0.841,1.69,1.879C351.362,117.652,350.435,118.493,349.398,118.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M378.602,124.433l-1.257,12.467h-25.17c0.096-2.439-1.73-4.369-4.19-4.369c-2.47,0-4.685,1.93-5.08,4.369h-25.17l1.257-12.467 H378.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M373.899,124.5c0.105-1.046,0.786-1.359,0.786-1.359h-52c0,0-0.681,0.313-0.786,1.359 c-0.109,1.079,0.512,1.36,0.512,1.36h52C374.411,125.86,373.79,125.579,373.899,124.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "403.846,409.679 237.078,409.679 265.348,129.194 432.117,129.194  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M418.883,158.79H272.717c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h146.167 c0.276,0,0.5,0.224,0.5,0.5C419.383,158.567,419.16,158.79,418.883,158.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M291.757,145.521c-0.441,4.378-4.349,7.927-8.727,7.927c-4.379,0-7.571-3.549-7.129-7.927 c0.441-4.378,4.349-7.927,8.727-7.927C289.006,137.594,292.198,141.143,291.757,145.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M279.317,144.333c0,0-4.258,5.614-2.98,7.328s13.094-7.91,15.931-11.206 c2.838-3.296-0.493-1.978-0.493-1.978s1.251,0.07,0.582,1.088c-1.363,2.077-12.594,9.492-13.741,9.097 C277.47,148.266,279.317,144.333,279.317,144.333z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M418.643,142.863H403.61c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h15.033c0.552,0,1,0.448,1,1 C419.643,142.415,419.195,142.863,418.643,142.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M418.173,147.521h-9.692c-0.552,0-1-0.448-1-1s0.448-1,1-1h9.692c0.552,0,1,0.448,1,1 S418.726,147.521,418.173,147.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M417.704,152.179h-25.319c-0.552,0-1-0.448-1-1s0.448-1,1-1h25.319c0.552,0,1,0.448,1,1 S418.256,152.179,417.704,152.179z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.527,170.788c0.252-2.506,2.354-4.317,4.933-4.317c1.367,0,2.493,0.492,3.18,1.403l-1.102,0.948 c-0.545-0.66-1.268-0.984-2.144-0.984c-1.739,0-3.122,1.223-3.296,2.95c-0.174,1.727,0.962,2.951,2.701,2.951 c0.875,0,1.664-0.324,2.343-0.996l0.911,0.959c-0.871,0.912-2.096,1.403-3.475,1.403 C312.01,175.106,310.274,173.295,310.527,170.788z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.071,170.788c0.25-2.482,2.354-4.317,4.957-4.317c2.603,0,4.338,1.823,4.086,4.317 c-0.251,2.495-2.354,4.318-4.957,4.318C320.554,175.106,318.82,173.271,319.071,170.788z M326.543,170.788 c0.173-1.715-0.962-2.95-2.653-2.95c-1.691,0-3.075,1.235-3.248,2.95c-0.173,1.715,0.962,2.951,2.653,2.951 C324.985,173.739,326.369,172.503,326.543,170.788z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.657,166.591l-0.846,8.395h-1.283l-4.057-5.685l-0.573,5.685h-1.547l0.846-8.395h1.283l4.057,5.685l0.573-5.685 H337.657z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.487,167.91h-2.783l0.133-1.319h7.124l-0.133,1.319h-2.782l-0.713,7.077h-1.559L341.487,167.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.788,174.986l-1.468-2.459c-0.109,0.012-0.217,0.012-0.325,0.012h-1.895l-0.247,2.447h-1.559l0.846-8.395h3.454 c2.207,0,3.46,1.127,3.273,2.986c-0.129,1.271-0.871,2.207-2.055,2.65l1.653,2.759H351.788z M350.39,167.91h-1.823l-0.337,3.346 h1.823c1.368,0,2.138-0.624,2.245-1.679C352.403,168.521,351.758,167.91,350.39,167.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.707,173.044h-4.198l-1.023,1.943h-1.607l4.624-8.395h1.535l2.944,8.395h-1.631L360.707,173.044z M360.315,171.82 l-1.213-3.67l-1.941,3.67H360.315z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.758,170.788c0.252-2.506,2.354-4.317,4.933-4.317c1.367,0,2.493,0.492,3.18,1.403l-1.103,0.948 c-0.545-0.66-1.268-0.984-2.144-0.984c-1.739,0-3.122,1.223-3.296,2.95c-0.174,1.727,0.962,2.951,2.701,2.951 c0.875,0,1.663-0.324,2.343-0.996l0.911,0.959c-0.871,0.912-2.096,1.403-3.476,1.403 C365.242,175.106,363.505,173.295,363.758,170.788z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.979,167.91h-2.783l0.133-1.319h7.124l-0.133,1.319h-2.782l-0.713,7.077h-1.559L374.979,167.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M305.669,186.79h-33.964c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h33.964c0.552,0,1,0.448,1,1 C306.669,186.342,306.222,186.79,305.669,186.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M288.143,192.192h-16.982c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h16.982c0.552,0,1,0.448,1,1 C289.143,191.745,288.695,192.192,288.143,192.192z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M409.91,220.422H268.316c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1H409.91c0.552,0,1,0.448,1,1 C410.91,219.975,410.462,220.422,409.91,220.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M409.289,226.585H267.695c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h141.594 c0.552,0,1,0.448,1,1C410.289,226.137,409.841,226.585,409.289,226.585z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M408.667,232.748H267.073c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594 c0.552,0,1,0.447,1,1C409.667,232.301,409.219,232.748,408.667,232.748z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M408.046,238.911H266.452c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594 c0.552,0,1,0.447,1,1C409.046,238.464,408.598,238.911,408.046,238.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M407.425,245.073H265.831c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594 c0.552,0,1,0.447,1,1C408.425,244.626,407.977,245.073,407.425,245.073z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.804,251.236H265.21c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594c0.552,0,1,0.447,1,1 C407.804,250.789,407.356,251.236,406.804,251.236z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.183,257.399H264.589c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594 c0.552,0,1,0.447,1,1C407.183,256.952,406.735,257.399,406.183,257.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M405.561,263.563H263.968c-0.552,0-1-0.447-1-1s0.448-1,1-1h141.594c0.552,0,1,0.447,1,1 S406.114,263.563,405.561,263.563z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M334.94,269.725h-71.594c-0.552,0-1-0.447-1-1s0.448-1,1-1h71.594c0.552,0,1,0.447,1,1 S335.493,269.725,334.94,269.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M414.351,186.79h-24.418c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1h24.418c0.552,0,1,0.448,1,1 C415.351,186.342,414.903,186.79,414.351,186.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M404.161,278.081H277.644c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h126.517 c0.552,0,1,0.447,1,1C405.161,277.634,404.713,278.081,404.161,278.081z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M403.477,284.244H261.883c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594 c0.552,0,1,0.447,1,1C404.477,283.797,404.029,284.244,403.477,284.244z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M402.855,290.407H261.262c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594 c0.552,0,1,0.447,1,1C403.855,289.96,403.408,290.407,402.855,290.407z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M402.234,296.57H260.641c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594c0.552,0,1,0.447,1,1 C403.234,296.123,402.787,296.57,402.234,296.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M401.613,302.732H260.02c-0.552,0-1-0.447-1-1c0-0.553,0.448-1,1-1h141.594c0.552,0,1,0.447,1,1 C402.613,302.285,402.165,302.732,401.613,302.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M310.992,308.896h-51.594c-0.552,0-1-0.447-1-1s0.448-1,1-1h51.594c0.552,0,1,0.447,1,1 S311.544,308.896,310.992,308.896z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "403.846,409.679 237.078,409.679 265.348,129.194 432.117,129.194  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M376.857,401.208c-55.589,0-111.179,0-166.769,0c30.62-90.217,49.12-181.797,53.26-272.014 c55.59,0,111.179,0,166.768,0C425.977,219.411,407.477,310.991,376.857,401.208z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M417.109,157.795c-48.722,0-97.444,0-146.166,0c-0.274,0-0.506-0.216-0.513-0.484 c-0.008-0.268,0.21-0.484,0.487-0.484c48.722,0,97.444,0,146.166,0c0.276,0,0.507,0.216,0.513,0.484 C417.603,157.579,417.386,157.795,417.109,157.795z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M289.544,144.962c-0.266,4.231-4.066,7.664-8.443,7.664c-4.379,0-7.68-3.433-7.414-7.664 c0.267-4.231,4-7.658,8.379-7.658C286.444,137.303,289.81,140.731,289.544,144.962z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.055,143.813c0.005-0.001-4.035,5.426-2.706,7.085c1.346,1.657,12.819-7.649,15.49-10.832 c2.687-3.184-0.585-1.91-0.584-1.91c-0.001,0,1.255,0.067,0.633,1.051c-1.257,2.005-12.197,9.173-13.365,8.791 C275.364,147.615,277.058,143.813,277.055,143.813z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M416.32,142.393c-5.011,0-10.022,0-15.033,0c-0.553,0-1.019-0.433-1.043-0.966 c-0.025-0.533,0.404-0.966,0.956-0.966c5.011,0,10.022,0,15.033,0c0.552,0,1.022,0.433,1.044,0.966 C417.301,141.96,416.872,142.393,416.32,142.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M416.038,146.895c-3.231,0-6.462,0-9.692,0c-0.553,0-1.016-0.433-1.038-0.967 c-0.021-0.534,0.41-0.967,0.961-0.967c3.231,0,6.462,0,9.692,0c0.553,0,1.016,0.433,1.039,0.967 C417.022,146.462,416.591,146.895,416.038,146.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M415.733,151.399c-8.439,0-16.879,0-25.319,0c-0.551,0-1.016-0.433-1.034-0.967 c-0.021-0.534,0.414-0.967,0.965-0.967c8.439,0,16.879,0,25.319,0c0.553,0,1.015,0.433,1.035,0.967 C416.72,150.966,416.286,151.399,415.733,151.399z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M308.997,169.411c0.216-2.428,2.282-4.181,4.862-4.181c1.368,0,2.503,0.476,3.205,1.359 c-0.362,0.306-0.724,0.612-1.087,0.918c-0.557-0.639-1.285-0.953-2.16-0.953c-1.739,0-3.1,1.184-3.25,2.857 c-0.15,1.673,1,2.859,2.739,2.859c0.874,0,1.66-0.314,2.331-0.965c0.307,0.31,0.615,0.62,0.922,0.93 c-0.86,0.884-2.08,1.36-3.46,1.36C310.53,173.594,308.781,171.839,308.997,169.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.541,169.411c0.214-2.405,2.284-4.181,4.886-4.181c2.602,0,4.374,1.765,4.157,4.181 c-0.217,2.416-2.302,4.183-4.905,4.183C319.076,173.594,317.327,171.816,317.541,169.411z M325.012,169.411 c0.148-1.661-1.009-2.857-2.699-2.857c-1.691,0-3.053,1.196-3.202,2.857c-0.15,1.661,1,2.859,2.691,2.859 C323.494,172.27,324.862,171.072,325.012,169.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.058,165.346c-0.231,2.71-0.473,5.421-0.727,8.132c-0.428,0-0.855,0-1.283,0c-1.371-1.836-2.748-3.672-4.13-5.507 c-0.161,1.835-0.328,3.671-0.5,5.507c-0.516,0-1.031,0-1.547,0c0.254-2.712,0.496-5.422,0.727-8.132c0.428,0,0.855,0,1.283,0 c1.388,1.835,2.769,3.67,4.146,5.506c0.167-1.836,0.329-3.671,0.484-5.506C335.026,165.346,335.543,165.346,336.058,165.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.912,166.623c-0.928,0-1.855,0-2.783,0c0.037-0.426,0.073-0.851,0.109-1.277c2.375,0,4.749,0,7.124,0 c-0.036,0.426-0.073,0.851-0.109,1.277c-0.927,0-1.855,0-2.782,0c-0.198,2.284-0.404,4.569-0.617,6.855c-0.52,0-1.039,0-1.559,0 C339.509,171.192,339.714,168.907,339.912,166.623z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.308,173.478c-0.498-0.794-0.996-1.588-1.496-2.382c-0.109,0.012-0.218,0.012-0.324,0.012c-0.631,0-1.264,0-1.895,0 c-0.072,0.79-0.145,1.58-0.219,2.371c-0.52,0-1.039,0-1.559,0c0.255-2.712,0.497-5.422,0.727-8.132c1.151,0,2.302,0,3.454,0 c2.206,0,3.482,1.091,3.324,2.892c-0.108,1.232-0.839,2.137-2.017,2.567c0.563,0.891,1.124,1.782,1.684,2.673 C351.427,173.478,350.868,173.478,350.308,173.478z M348.815,166.623c-0.608,0-1.215,0-1.823,0 c-0.094,1.08-0.188,2.161-0.286,3.241c0.607,0,1.215,0,1.823,0c1.368,0,2.131-0.604,2.22-1.626 C350.839,167.215,350.182,166.623,348.815,166.623z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.207,171.596c-1.399,0-2.798,0-4.198,0c-0.334,0.627-0.667,1.255-1.002,1.882c-0.536,0-1.072,0-1.607,0 c1.513-2.712,3.015-5.422,4.505-8.132c0.512,0,1.023,0,1.535,0c1.033,2.71,2.054,5.421,3.063,8.132c-0.544,0-1.087,0-1.631,0 C359.651,172.85,359.429,172.223,359.207,171.596z M358.799,170.411c-0.421-1.185-0.843-2.37-1.268-3.555 c-0.626,1.185-1.255,2.37-1.886,3.555C356.696,170.411,357.748,170.411,358.799,170.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.228,169.411c0.218-2.428,2.284-4.181,4.862-4.181c1.367,0,2.503,0.476,3.205,1.359 c-0.362,0.306-0.724,0.612-1.087,0.918c-0.556-0.639-1.284-0.953-2.16-0.953c-1.739,0-3.1,1.184-3.25,2.857 c-0.148,1.673,0.999,2.859,2.739,2.859c0.875,0,1.659-0.314,2.331-0.965c0.308,0.31,0.615,0.62,0.922,0.93 c-0.861,0.884-2.083,1.36-3.46,1.36C363.761,173.594,362.012,171.839,362.228,169.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.403,166.623c-0.927,0-1.855,0-2.783,0c0.036-0.426,0.073-0.851,0.109-1.277c2.375,0,4.749,0,7.124,0 c-0.036,0.426-0.072,0.851-0.109,1.277c-0.927,0-1.855,0-2.782,0c-0.197,2.284-0.403,4.569-0.617,6.855 c-0.519,0-1.039,0-1.559,0C373,171.192,373.207,168.907,373.403,166.623z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M304.236,184.919c-11.321,0-22.643,0-33.964,0c-0.552,0-1-0.434-0.998-0.97 c0.001-0.535,0.448-0.97,1.001-0.97c11.322,0,22.642,0,33.964,0c0.553,0,1,0.434,0.999,0.97 C305.237,184.485,304.791,184.919,304.236,184.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M286.684,190.159c-5.661,0-11.321,0-16.982,0c-0.553,0-0.998-0.434-0.993-0.97 c0.004-0.536,0.455-0.97,1.006-0.97c5.66,0,11.322,0,16.982,0c0.553,0,0.996,0.434,0.994,0.97 C287.686,189.725,287.237,190.159,286.684,190.159z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M407.833,217.562c-47.197,0-94.396,0-141.593,0c-0.553,0-0.984-0.435-0.964-0.971 c0.019-0.536,0.482-0.971,1.035-0.971c47.198,0,94.396,0,141.593,0c0.551,0,0.984,0.435,0.965,0.971 C408.849,217.128,408.384,217.562,407.833,217.562z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.97,223.549c-47.198,0-94.396,0-141.594,0c-0.551,0-0.982-0.435-0.958-0.972 c0.023-0.536,0.488-0.972,1.041-0.971c47.198,0,94.396,0,141.594,0c0.552,0,0.981,0.435,0.959,0.971 C407.987,223.114,407.521,223.549,406.97,223.549z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M406.068,229.537c-47.198,0-94.396,0-141.593,0c-0.553,0-0.977-0.435-0.952-0.972 c0.026-0.537,0.492-0.971,1.047-0.972c47.198,0,94.396,0,141.594,0c0.551,0,0.979,0.435,0.953,0.972 C407.088,229.103,406.619,229.537,406.068,229.537z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M405.127,235.527c-47.198,0-94.396,0-141.594,0c-0.554,0-0.974-0.435-0.945-0.972 c0.03-0.537,0.502-0.972,1.053-0.972c47.198,0,94.396,0,141.594,0c0.551,0,0.977,0.435,0.947,0.972 C406.152,235.092,405.677,235.527,405.127,235.527z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M404.149,241.516c-47.198,0-94.396,0-141.594,0c-0.55,0-0.972-0.435-0.939-0.972 c0.031-0.537,0.509-0.972,1.06-0.972c47.198,0,94.396,0,141.594,0c0.552,0,0.975,0.435,0.94,0.972 C405.173,241.081,404.702,241.516,404.149,241.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M403.132,247.507c-47.198,0-94.396,0-141.594,0c-0.551,0-0.969-0.435-0.933-0.972 c0.036-0.537,0.514-0.972,1.066-0.972c47.198,0,94.396,0,141.594,0c0.553,0,0.97,0.435,0.934,0.972 C404.162,247.072,403.685,247.507,403.132,247.507z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M402.077,253.498c-47.198,0-94.396,0-141.594,0c-0.551,0-0.967-0.435-0.927-0.972 c0.04-0.538,0.521-0.972,1.072-0.972c47.198,0,94.396,0,141.593,0c0.551,0,0.968,0.435,0.928,0.972 C403.109,253.063,402.627,253.498,402.077,253.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M400.983,259.49c-47.198,0-94.396,0-141.594,0c-0.554,0-0.964-0.435-0.921-0.972 c0.043-0.538,0.527-0.972,1.078-0.972c47.198,0,94.396,0,141.594,0c0.551,0,0.966,0.435,0.922,0.972 C402.017,259.055,401.536,259.49,400.983,259.49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M329.851,265.481c-23.865,0-47.729,0-71.594,0c-0.551,0-0.962-0.435-0.914-0.972 c0.049-0.537,0.532-0.972,1.085-0.972c23.865,0,47.729,0,71.594,0c0.553,0,0.963,0.435,0.915,0.972 C330.89,265.046,330.403,265.481,329.851,265.481z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M412.918,184.919c-8.139,0-16.278,0-24.418,0c-0.551,0-0.999-0.434-0.998-0.97 c-0.002-0.535,0.449-0.97,1.001-0.97c8.139,0,16.279,0,24.417,0c0.552,0,1.001,0.434,1,0.97 C413.92,184.485,413.472,184.919,412.918,184.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M398.317,273.605c-42.172,0-84.344,0-126.517,0c-0.553,0-0.959-0.435-0.906-0.972 c0.05-0.538,0.539-0.972,1.093-0.972c42.172,0,84.344,0,126.517,0c0.553,0,0.958,0.435,0.907,0.972 C399.359,273.17,398.87,273.605,398.317,273.605z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M397.032,279.597c-47.198,0-94.396,0-141.594,0c-0.553,0-0.954-0.435-0.9-0.972 c0.056-0.537,0.547-0.972,1.099-0.972c47.198,0,94.396,0,141.594,0c0.553,0,0.957,0.435,0.901,0.972 C398.077,279.162,397.585,279.597,397.032,279.597z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M395.77,285.588c-47.198,0-94.396,0-141.593,0c-0.552,0-0.953-0.435-0.893-0.972 c0.057-0.537,0.554-0.972,1.105-0.972c47.198,0,94.396,0,141.593,0c0.553,0,0.955,0.435,0.895,0.972 C396.817,285.153,396.323,285.588,395.77,285.588z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M394.471,291.579c-47.198,0-94.396,0-141.594,0c-0.554,0-0.949-0.435-0.887-0.972 c0.062-0.537,0.56-0.972,1.112-0.972c47.197,0,94.396,0,141.593,0c0.554,0,0.95,0.435,0.888,0.972 C395.52,291.144,395.022,291.578,394.471,291.579z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M393.134,297.568c-47.198,0-94.396,0-141.593,0c-0.55,0-0.947-0.435-0.881-0.972 c0.064-0.537,0.566-0.972,1.118-0.972c47.198,0,94.395,0,141.593,0c0.551,0,0.949,0.435,0.882,0.972 C394.187,297.133,393.686,297.568,393.134,297.568z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M301.759,303.556c-17.198,0-34.396,0-51.594,0c-0.551,0-0.944-0.435-0.875-0.972 c0.069-0.537,0.571-0.971,1.124-0.972c17.198,0,34.396,0,51.594,0c0.552,0,0.943,0.434,0.876,0.972 C302.814,303.122,302.31,303.557,301.759,303.556z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.857,401.208c-55.589,0-111.179,0-166.769,0c30.62-90.217,49.12-181.797,53.26-272.014c55.59,0,111.179,0,166.768,0 C425.977,219.411,407.477,310.991,376.857,401.208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M354.215,383.547c-55.589,0-111.179,0-166.768,0c38.461-84.359,63.921-169.993,75.902-254.352 c55.59,0,111.179,0,166.768,0C418.135,213.553,392.676,299.187,354.215,383.547z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M415.624,155.938c-48.722,0-97.444,0-146.166,0c-0.274,0-0.487-0.202-0.471-0.452 c0.015-0.25,0.252-0.452,0.529-0.452c48.722,0,97.444,0,146.166,0c0.276,0,0.488,0.202,0.471,0.452 C416.136,155.736,415.9,155.938,415.624,155.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M289.173,143.938c-0.634,3.957-4.732,7.167-9.109,7.167c-4.379,0-7.382-3.21-6.747-7.167 c0.635-3.957,4.666-7.161,9.045-7.161C286.739,136.777,289.807,139.982,289.173,143.938z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M276.785,142.864c0.006,0-4.506,5.074-3.322,6.625c1.202,1.549,13.483-7.153,16.432-10.129 c2.964-2.977-0.419-1.786-0.418-1.786c-0.001,0,1.249,0.063,0.542,0.982c-1.431,1.875-12.994,8.577-14.129,8.221 C274.763,146.419,276.787,142.864,276.785,142.864z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M416.172,141.536c-5.011,0-10.022,0-15.033,0c-0.553,0-0.981-0.405-0.959-0.903 c0.022-0.499,0.488-0.904,1.04-0.904c5.011,0,10.022,0,15.033,0c0.553,0,0.984,0.405,0.96,0.904 C417.192,141.131,416.724,141.536,416.172,141.536z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M415.499,145.746c-3.231,0-6.462,0-9.692,0c-0.553,0-0.978-0.405-0.954-0.904 c0.026-0.499,0.494-0.904,1.045-0.904c3.231,0,6.462,0,9.692,0c0.552,0,0.979,0.405,0.955,0.904 C416.521,145.341,416.053,145.746,415.499,145.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M414.803,149.958c-8.44,0-16.879,0-25.319,0c-0.551,0-0.978-0.405-0.95-0.904 c0.026-0.499,0.498-0.904,1.049-0.904c8.439,0,16.879,0,25.319,0c0.553,0,0.977,0.405,0.951,0.904 C415.828,149.553,415.357,149.958,414.803,149.958z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M256.879,369.428c-17.059,0-34.117,0-51.176,0c-0.552,0-0.866-0.404-0.706-0.904 c0.162-0.5,0.741-0.904,1.294-0.904c17.059,0,34.117,0,51.176,0c0.553,0,0.87,0.404,0.706,0.904 C258.01,369.024,257.431,369.428,256.879,369.428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.781,369.428c-19.682,0-39.365,0-59.047,0c-0.551,0-0.867-0.404-0.706-0.904 c0.163-0.5,0.741-0.904,1.294-0.904c19.682,0,39.365,0,59.047,0c0.551,0,0.87,0.404,0.706,0.904 C349.914,369.024,349.332,369.428,348.781,369.428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M266.075,317.065c-9.044,0-18.087,0-27.131,0c-0.551,0-0.891-0.406-0.763-0.908 c0.13-0.501,0.684-0.907,1.236-0.908c9.044,0,18.087,0,27.131,0c0.551,0,0.895,0.406,0.764,0.908 C267.181,316.658,266.628,317.064,266.075,317.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M360.238,317.065c-13.175,0-26.349,0-39.524,0c-0.552,0-0.893-0.406-0.763-0.908 c0.129-0.501,0.684-0.907,1.236-0.908c13.174,0,26.349,0,39.524,0c0.553,0,0.894,0.406,0.764,0.908 C361.346,316.658,360.79,317.064,360.238,317.065z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M317.107,358.833c-0.973,0-1.796-0.159-2.412-0.518c-1.279-0.737-1.585-1.987-0.898-3.612 c0.096-0.228,0.212-0.462,0.345-0.7c-4.174,1.553-8.474,2.702-12.034,2.934c-2.46,0.156-3.055-0.805-3.122-1.645 c-0.118-1.489,1.346-3.867,3.678-6.614c-5.404,2.416-9.368,3.892-9.447,3.922c-0.284,0.106-0.551,0.006-0.596-0.221 c-0.048-0.227,0.145-0.496,0.428-0.601c0.089-0.033,4.802-1.789,10.946-4.605c6.239-6.799,16.615-15.154,22.009-18.023 c3.869-2.054,6.115-2.611,6.693-1.661c0.905,1.494-3.515,5.97-10.807,10.881c-5.422,3.654-11.892,6.946-17.316,9.441 c-2.818,3.085-4.665,5.738-4.551,7.18c0.024,0.293,0.095,1.184,2.293,1.041c3.668-0.239,8.247-1.527,12.602-3.219 c3.121-4.213,10.37-9.197,13.691-10.029c1.28-0.32,1.788,0.01,1.99,0.342c0.19,0.315,0.271,0.88-0.423,1.778 c-1.771,2.297-7.916,5.901-14.671,8.574c-0.312,0.456-0.565,0.897-0.74,1.315c-0.534,1.267-0.322,2.158,0.656,2.724 c2.245,1.294,8.04-0.546,13.726-3.189c0.04-0.281,0.132-0.582,0.272-0.903c1.6-3.642,9.423-9.278,13.587-9.032 c0.826,0.049,1.021,0.418,1.042,0.718c0.086,1.315-3.434,3.77-6.408,5.595c-2.092,1.285-4.71,2.722-7.444,4.026 c0.136,0.494,0.623,0.807,1.47,0.947c6.186,1.02,20.655-8.049,20.785-8.141c0.257-0.165,0.567-0.143,0.691,0.046 c0.125,0.19,0.015,0.476-0.243,0.639c-0.595,0.387-15.059,9.448-21.681,8.348c-1.115-0.185-1.8-0.663-2.019-1.372 C324.777,357.233,320.185,358.832,317.107,358.833z M342.455,345.294c-3.658,0-10.713,5.141-12.079,8.241 c-0.038,0.09-0.075,0.177-0.102,0.261c2.482-1.203,4.897-2.529,6.932-3.781c4.279-2.63,5.829-4.23,5.803-4.619 c-0.001-0.025-0.086-0.08-0.339-0.096C342.601,345.296,342.529,345.294,342.455,345.294z M329.264,343.562 c-0.207,0-0.453,0.049-0.626,0.093c-2.86,0.716-8.917,4.834-12.112,8.514c6.008-2.498,11.301-5.631,12.835-7.619 c0.299-0.387,0.396-0.673,0.291-0.848C329.591,343.598,329.442,343.562,329.264,343.562z M331.393,327.951 c-0.612,0-2.057,0.372-5.031,1.948c-5.163,2.743-14.194,10.074-20.254,16.291c4.952-2.346,10.537-5.275,15.296-8.483 c7.673-5.174,10.762-8.977,10.356-9.65C331.726,327.999,331.615,327.951,331.393,327.951z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.501,166.799c0.427-2.27,2.645-3.91,5.225-3.91c1.368,0,2.462,0.445,3.087,1.271 c-0.389,0.286-0.778,0.572-1.167,0.858c-0.501-0.597-1.202-0.891-2.077-0.891c-1.739,0-3.203,1.108-3.498,2.672 c-0.296,1.564,0.751,2.674,2.49,2.673c0.874,0,1.688-0.294,2.415-0.902c0.28,0.29,0.561,0.579,0.841,0.869 c-0.936,0.826-2.199,1.271-3.579,1.271C307.671,170.711,306.074,169.07,306.501,166.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.045,166.799c0.423-2.248,2.647-3.91,5.249-3.91c2.602,0,4.22,1.65,3.794,3.91c-0.427,2.26-2.666,3.911-5.269,3.911 C316.217,170.711,314.622,169.049,315.045,166.799z M322.517,166.799c0.292-1.553-0.76-2.672-2.451-2.672 c-1.691,0-3.158,1.119-3.45,2.672c-0.294,1.553,0.752,2.673,2.443,2.673C320.75,169.473,322.222,168.353,322.517,166.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.916,162.999c-0.466,2.534-0.944,5.069-1.434,7.604c-0.428,0-0.855,0-1.283,0c-1.212-1.717-2.429-3.434-3.651-5.15 c-0.32,1.716-0.647,3.433-0.978,5.15c-0.516,0-1.032,0-1.547,0c0.49-2.536,0.968-5.07,1.434-7.604c0.428,0,0.855,0,1.283,0 c1.228,1.716,2.45,3.432,3.667,5.149c0.326-1.716,0.648-3.433,0.962-5.149C332.884,162.999,333.401,162.999,333.916,162.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.659,164.193c-0.927,0-1.855,0-2.782,0c0.074-0.398,0.147-0.796,0.22-1.194c2.375,0,4.749,0,7.124,0 c-0.073,0.398-0.147,0.796-0.22,1.194c-0.927,0-1.855,0-2.782,0c-0.396,2.136-0.801,4.273-1.213,6.41c-0.52,0-1.039,0-1.559,0 C336.858,168.465,337.263,166.329,337.659,164.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46,170.603c-0.429-0.743-0.858-1.485-1.288-2.228c-0.111,0.011-0.219,0.011-0.326,0.011c-0.631,0-1.264,0-1.895,0 c-0.141,0.739-0.283,1.478-0.425,2.217c-0.52,0-1.039,0-1.559,0c0.49-2.536,0.968-5.07,1.434-7.604c1.151,0,2.302,0,3.454,0 c2.206,0,3.388,1.02,3.073,2.704c-0.215,1.152-1.025,1.998-2.241,2.4c0.485,0.833,0.969,1.666,1.452,2.499 C348.579,170.603,348.019,170.603,347.46,170.603z M346.561,164.193c-0.607,0-1.215,0-1.823,0 c-0.187,1.01-0.376,2.02-0.568,3.031c0.607,0,1.215,0,1.823,0c1.368,0,2.183-0.565,2.362-1.52 C348.535,164.747,347.929,164.193,346.561,164.193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.521,168.842c-1.399,0-2.798,0-4.198,0c-0.388,0.587-0.776,1.173-1.165,1.76c-0.536,0-1.072,0-1.607,0 c1.749-2.536,3.487-5.07,5.211-7.604c0.512,0,1.024,0,1.535,0c0.797,2.534,1.583,5.069,2.357,7.604c-0.544,0-1.087,0-1.631,0 C356.856,170.016,356.689,169.429,356.521,168.842z M356.217,167.734c-0.318-1.108-0.637-2.216-0.959-3.324 c-0.729,1.108-1.461,2.216-2.195,3.324C354.114,167.734,355.165,167.734,356.217,167.734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.733,166.799c0.429-2.27,2.647-3.91,5.225-3.91c1.367,0,2.462,0.445,3.087,1.271 c-0.388,0.286-0.777,0.572-1.167,0.858c-0.501-0.597-1.201-0.891-2.077-0.891c-1.739,0-3.202,1.108-3.498,2.672 c-0.294,1.564,0.751,2.674,2.49,2.673c0.876,0,1.687-0.294,2.415-0.902c0.281,0.29,0.561,0.579,0.841,0.869 c-0.938,0.826-2.202,1.271-3.579,1.271C360.902,170.711,359.305,169.07,359.733,166.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,164.193c-0.927,0-1.855,0-2.783,0c0.073-0.398,0.147-0.796,0.22-1.194c2.375,0,4.749,0,7.124,0 c-0.073,0.398-0.146,0.796-0.22,1.194c-0.928,0-1.855,0-2.782,0c-0.396,2.136-0.8,4.273-1.213,6.41c-0.519,0-1.039,0-1.559,0 C370.35,168.465,370.755,166.329,371.15,164.193z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M300.393,181.301c-11.321,0-22.643,0-33.964,0c-0.552,0-0.963-0.406-0.914-0.907 c0.047-0.501,0.532-0.907,1.085-0.907c11.322,0,22.642,0,33.964,0c0.553,0,0.963,0.406,0.915,0.907 C301.431,180.895,300.947,181.301,300.393,181.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M282.385,186.201c-5.661,0-11.321,0-16.982,0c-0.553,0-0.96-0.406-0.909-0.907 c0.051-0.501,0.539-0.907,1.091-0.907c5.66,0,11.321,0,16.982,0c0.553,0,0.959,0.406,0.91,0.907 C283.425,185.794,282.938,186.201,282.385,186.201z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M401.152,211.825c-47.198,0-94.396,0-141.594,0c-0.553,0-0.946-0.407-0.88-0.908 c0.065-0.501,0.567-0.908,1.119-0.908c47.198,0,94.396,0,141.594,0c0.551,0,0.946,0.407,0.881,0.908 C402.206,211.418,401.704,211.825,401.152,211.825z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M399.769,217.423c-47.198,0-94.396,0-141.593,0c-0.551,0-0.944-0.407-0.874-0.908 c0.07-0.502,0.572-0.909,1.126-0.908c47.198,0,94.396,0,141.594,0c0.552,0,0.943,0.407,0.874,0.908 C400.824,217.016,400.321,217.423,399.769,217.423z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M398.346,223.022c-47.198,0-94.396,0-141.594,0c-0.553,0-0.94-0.406-0.867-0.909 c0.073-0.502,0.577-0.908,1.132-0.909c47.198,0,94.396,0,141.594,0c0.551,0,0.941,0.407,0.868,0.909 C399.404,222.616,398.898,223.022,398.346,223.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M396.885,228.623c-47.198,0-94.396,0-141.594,0c-0.554,0-0.937-0.406-0.861-0.909 c0.076-0.502,0.587-0.909,1.138-0.909c47.198,0,94.396,0,141.593,0c0.551,0,0.939,0.406,0.862,0.909 C397.948,228.216,397.436,228.623,396.885,228.623z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M395.387,234.223c-47.198,0-94.396,0-141.594,0c-0.55,0-0.935-0.407-0.855-0.909 c0.078-0.502,0.593-0.909,1.144-0.909c47.198,0,94.395,0,141.593,0c0.552,0,0.937,0.406,0.856,0.909 C396.448,233.816,395.94,234.223,395.387,234.223z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M393.849,239.825c-47.198,0-94.396,0-141.593,0c-0.551,0-0.932-0.407-0.849-0.909 c0.083-0.502,0.598-0.909,1.15-0.909c47.198,0,94.396,0,141.594,0c0.553,0,0.932,0.407,0.85,0.909 C394.917,239.418,394.402,239.825,393.849,239.825z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M392.273,245.427c-47.198,0-94.396,0-141.594,0c-0.551,0-0.929-0.407-0.842-0.909 c0.086-0.503,0.606-0.909,1.157-0.909c47.198,0,94.396,0,141.593,0c0.551,0,0.93,0.407,0.843,0.909 C393.343,245.021,392.823,245.427,392.273,245.427z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M390.658,251.03c-47.198,0-94.396,0-141.594,0c-0.554,0-0.926-0.407-0.836-0.909 c0.09-0.503,0.612-0.909,1.163-0.909c47.198,0,94.396,0,141.593,0c0.551,0,0.928,0.406,0.837,0.909 C391.73,250.624,391.211,251.03,390.658,251.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M319.005,256.632c-23.865,0-47.729,0-71.594,0c-0.551,0-0.924-0.406-0.83-0.909 c0.096-0.503,0.617-0.909,1.169-0.909c23.865,0,47.729,0,71.594,0c0.553,0,0.925,0.407,0.831,0.909 C320.082,256.226,319.557,256.632,319.005,256.632z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M409.074,181.301c-8.139,0-16.278,0-24.417,0c-0.551,0-0.961-0.406-0.914-0.907 c0.045-0.501,0.533-0.907,1.085-0.907c8.139,0,16.279,0,24.417,0c0.552,0,0.963,0.406,0.915,0.907 C410.114,180.895,409.628,181.301,409.074,181.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M386.765,264.229c-42.172,0-84.344,0-126.517,0c-0.553,0-0.921-0.407-0.822-0.909 c0.097-0.503,0.624-0.909,1.178-0.909c42.172,0,84.344,0,126.517,0c0.553,0,0.921,0.406,0.822,0.909 C387.845,263.822,387.319,264.229,386.765,264.229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M384.96,269.831c-47.198,0-94.396,0-141.594,0c-0.553,0-0.916-0.407-0.815-0.909 c0.103-0.502,0.631-0.909,1.184-0.909c47.198,0,94.396,0,141.594,0c0.553,0,0.919,0.406,0.816,0.909 C386.043,269.425,385.513,269.831,384.96,269.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M383.177,275.434c-47.197,0-94.396,0-141.593,0c-0.552,0-0.915-0.407-0.809-0.909 c0.104-0.502,0.639-0.909,1.19-0.909c47.198,0,94.396,0,141.593,0c0.553,0,0.918,0.407,0.81,0.909 C384.262,275.027,383.73,275.434,383.177,275.434z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M381.358,281.035c-47.197,0-94.396,0-141.593,0c-0.554,0-0.911-0.406-0.803-0.909 c0.109-0.502,0.644-0.909,1.196-0.909c47.197,0,94.396,0,141.593,0c0.554,0,0.912,0.406,0.804,0.909 C382.444,280.629,381.909,281.035,381.358,281.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M379.5,286.635c-47.198,0-94.396,0-141.594,0c-0.55,0-0.909-0.406-0.797-0.909 c0.111-0.502,0.651-0.909,1.202-0.909c47.198,0,94.395,0,141.593,0c0.551,0,0.911,0.406,0.798,0.909 C380.591,286.229,380.052,286.635,379.5,286.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M287.604,292.235c-17.198,0-34.396,0-51.594,0c-0.551,0-0.907-0.407-0.79-0.909 c0.116-0.502,0.655-0.908,1.208-0.909c17.198,0,34.396,0,51.594,0c0.552,0,0.905,0.406,0.792,0.909 C288.697,291.829,288.156,292.236,287.604,292.235z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M282.233,337.128c0.51-0.446,1.786-1.433,2.552-2.022c0.332-0.255,0.762-0.282,0.945-0.06 c0.428,0.524,0.857,1.048,1.285,1.572c0.001,0-1.425,1.592-1.881,2.132c-4.599,5.454-7.352,10.692-6.984,11.694 c4.702-0.482,35.406-15.51,49.163-24.344c-3.055-6.376-10.315-10.359-20.205-9.908c-14.078,0.641-29.198,10.471-35.684,22.948 c-2.308,4.441-3.311,8.675-3.203,12.467C273.135,345.378,279.732,339.316,282.233,337.128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.098,362.796c3.374,3.13,8.382,4.981,14.682,4.981c15.73,0,33.57-11.527,39.319-25.784 c1.572-3.895,2.076-7.586,1.663-10.9C314.67,341.147,287.307,357.602,273.098,362.796z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M283.507,338.123c0.054,0.003-20.675,18.281-17.922,23.847c2.936,5.58,55.099-25.725,68.006-36.486 c13.087-10.748-0.055-6.449-0.043-6.449c-0.003,0,4.439,0.227,1.149,3.547c-6.588,6.779-54.064,30.926-57.882,29.633 C273.119,350.931,283.536,338.125,283.507,338.123z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M220.072,360.699c-7.352,0-8.825-2.853-8.75-5.307c0.254-7.28,14.447-19.736,29.249-25.626 c8.128-3.229,14.611-3.432,16.519-0.513c1.565,2.402-0.358,6.385-5.315,10.925c-9.8,8.962-17.902,11.002-21.482,9.056 c-0.551-0.297-0.963-0.677-1.238-1.116c-0.908,0.426-1.891,0.864-2.951,1.308c-0.282,0.118-0.558,0.033-0.619-0.188 c-0.064-0.221,0.112-0.495,0.391-0.612c1.058-0.444,2.006-0.867,2.858-1.267c-0.216-0.866,0.007-1.873,0.681-2.894 c1.388-2.097,3.917-3.142,5.582-3.065c0.945,0.046,1.493,0.467,1.462,1.13c-0.063,1.302-2.296,3.073-6.392,5.099 c0.215,0.311,0.525,0.583,0.924,0.799c2.427,1.321,9.473,0.959,20.128-8.784c4.559-4.176,6.383-7.751,5.042-9.808 c-1.662-2.548-7.839-2.249-15.376,0.741c-14.391,5.723-28.188,17.677-28.427,24.592c-0.101,3.204,2.967,4.805,8.939,4.607 c7.617-0.242,15.676-3.344,22.445-7.003c2.136-4.094,8.37-9.412,14.964-12.606c1.322-0.64,2.079-0.782,2.433-0.462 c0.275,0.245,0.22,0.668-0.164,1.257c-1.375,2.12-7.931,7.595-16.434,12.239c-0.115,0.24-0.211,0.474-0.292,0.701 c-0.443,1.274-0.28,2.248,0.499,2.894c2.818,2.34,13.066-4.634,16.741-7.522c0.241-0.185,0.558-0.204,0.718-0.04 c0.159,0.165,0.091,0.452-0.149,0.639c-0.553,0.45-14.152,10.96-18.127,7.652c-0.984-0.819-1.217-2.076-0.679-3.635 c-6.87,3.602-14.839,6.554-22.207,6.789C220.714,360.693,220.386,360.699,220.072,360.699z M260.237,340.463 c-0.169,0.033-0.53,0.14-1.224,0.476c-5.708,2.763-11.285,7.311-13.73,10.983c5.135-2.917,9.4-6.068,12.01-8.344 C259.365,341.771,260.071,340.807,260.237,340.463z M234.563,342.304c-1.145,0-3.148,0.734-4.284,2.449 c-0.493,0.741-0.665,1.476-0.535,2.12c4.34-2.151,5.656-3.574,5.681-4.145c0.016-0.348-0.514-0.41-0.744-0.421 C234.643,342.305,234.603,342.304,234.563,342.304z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__57_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M184.581,177.11c0,0-18.429-18.232-40.542-19.364c0,0-13.182,31.924-19.573,63.584l43.891,7.824 C168.357,229.154,174.388,196.302,184.581,177.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M184.58,177.11c-10.19,19.19-16.22,52.04-16.22,52.04 l-43.89-7.82c2.35-11.67,5.63-23.37,8.83-33.49c2.4-7.61,4.76-14.32,6.65-19.47c2.43-6.6,4.09-10.62,4.09-10.62 C166.15,158.88,184.58,177.11,184.58,177.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M175.08,158.89c-0.45,0.43-0.9,0.88-1.31,1.35c-0.07,0.09-0.15,0.17-0.22,0.26 c-0.9,1.06-1.64,2.19-2.02,3.39c-0.17,0.54-0.27,1.1-0.28,1.67c-0.02,1.62,0.67,3.34,2.49,5.18c-0.08,2.2-5.76,0.06-5.76,0.06 s-8.35-4.46-9.41-9.53c3.21-0.66,6.12-4.23,8.41-8.18c0.58-1,1.12-2.04,1.62-3.05c0.86-1.76,1.58-3.48,2.13-4.91L175.08,158.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M173.77,160.24c-0.07,0.09-0.15,0.17-0.22,0.26 c-0.9,1.06-1.64,2.19-2.02,3.39c-0.17,0.54-0.27,1.1-0.28,1.67c-2.45-2.33-5.57-6.73-4.27-12.47c0.25-1.15,0.69-2.35,1.34-3.6 l0.28,0.55L173.77,160.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M196.099,140.113c0,0-2.39,11.047-9.462,12.952c-7.072,1.905,0.332-17.533,0.332-17.533 L196.099,140.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M167.386,155.235c1.217,4.889,5.217,7.572,9.483,7.817c2.742,0.161,5.596-0.694,7.893-2.612 c0.305-0.248,0.597-0.523,0.883-0.811c5.158-5.342,10.277-16.173,5.123-22.926c-3.641-4.842-10.531-5.821-15.376-2.17 c-1.385,1.029-2.497,2.382-3.264,3.933C168.458,145.611,165.964,149.638,167.386,155.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M181.486,146.594c-0.368,0.535-0.307,1.191,0.068,1.411c0.374,0.22,0.937-0.069,1.271-0.628 c0.335-0.559,0.298-1.197-0.068-1.411C182.391,145.752,181.827,146.027,181.486,146.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M187.853,150.351c-0.368,0.535-0.298,1.197,0.068,1.411c0.366,0.214,0.936-0.069,1.271-0.628 c0.335-0.559,0.298-1.197-0.068-1.411C188.758,149.509,188.17,149.818,187.853,150.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M185.667,149.434c-0.346,2.118-0.397,4.274-0.152,6.406c-1.114,0.098-2.214-0.302-3.005-1.092 L185.667,149.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M191.819,149.024c-0.143-0.004-0.274-0.084-0.342-0.21c-0.43-0.876-1.249-1.498-2.209-1.678 c-0.21-0.02-0.363-0.206-0.344-0.416c0.02-0.21,0.206-0.364,0.416-0.344c0.001,0,0.001,0,0.002,0 c1.219,0.196,2.267,0.971,2.812,2.079c0.103,0.184,0.037,0.417-0.147,0.519c-0.003,0.001-0.005,0.003-0.008,0.004 C191.942,149.004,191.881,149.019,191.819,149.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M181.729,143.305c-0.066-0.041-0.116-0.102-0.145-0.174c-0.04-0.207,0.096-0.407,0.303-0.446 c0.003-0.001,0.005-0.001,0.008-0.002c1.215-0.242,2.471,0.123,3.368,0.978c0.144,0.154,0.135,0.396-0.019,0.539l-0.001,0.001 c-0.157,0.139-0.394,0.13-0.54-0.019l0,0c-0.727-0.654-1.721-0.925-2.68-0.732C181.909,143.446,181.801,143.394,181.729,143.305z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M182.295,132.831l-1.27,3.333c-1.315,0.006-2.546,0.837-2.723,2.321 c-0.378,3.167-4.027,6.464-6.907,7.027c0,0,0.539-1.174-0.566-1.411c-1.105-0.237-3.974,5.845-3.591,9.669 c0,0-1.488-4.062,0.198-11.145c1.56-6.551,3.911-11.456,6.274-13.063L182.295,132.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M165.761,142.354c-0.156,2.018,0.494,4.015,1.809,5.554c1.755,2.025,4.106,0.809,4.859-1.617 c0.649-2.163,0.566-5.879-1.808-6.995C168.247,138.181,165.984,139.88,165.761,142.354z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M181.024,156.278c-0.936,0.603-2.343,1.954-2.343,1.954c-0.145-0.105-0.291-0.211-0.43-0.324 c-1.936-1.479-2.346-2.805-2.212-3.826c0.075-0.558,0.32-1.027,0.565-1.376c0.279-0.406,0.571-0.631,0.571-0.631 c0.558,1.397,2.256,2.915,3.197,3.688C180.763,156.091,181.024,156.278,181.024,156.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M180.372,155.763l-0.706,0.558c-1.82-1.397-2.914-2.626-3.063-3.615 c0.279-0.406,0.571-0.631,0.571-0.631C177.732,153.473,179.431,154.99,180.372,155.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M178.251,157.908c-1.936-1.479-2.346-2.805-2.212-3.826c0.64,0.529,1.353,1.239,1.824,2.068 C178.225,156.783,178.296,157.387,178.251,157.908z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M181.026,136.164c0,0,14.413,12.038,16.799,0.119c0,0-6.921-8.715-15.295-10.238 c-8.374-1.523-10.867,6.799-10.867,6.799L181.026,136.164z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.071,410.194h-10.135c-0.342,0.002-0.637,0.24-0.711,0.573l-1.645,7.429c-0.141,0.665,0.284,1.318,0.95,1.459 c0.089,0.019,0.18,0.028,0.271,0.027c3.279-0.053,5.667-0.255,9.785-0.255c2.536,0,10.188,0.265,13.691,0.265 c3.502,0,3.959-3.46,2.526-3.778c-6.432-1.401-11.271-3.343-13.33-5.19C130.09,410.374,129.589,410.184,129.071,410.194z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.053,409.928h-10.135c-0.342,0.002-0.637,0.24-0.711,0.573l-1.645,7.429c-0.141,0.665,0.284,1.318,0.95,1.459 c0.089,0.019,0.18,0.028,0.271,0.027c3.279-0.053,5.667-0.255,9.785-0.255c2.537,0,10.188,0.265,13.691,0.265 c3.502,0,3.959-3.46,2.526-3.778c-6.431-1.401-11.271-3.343-13.33-5.19C173.072,410.109,172.571,409.919,172.053,409.928z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M124.466,217.725l44.934,6.725c0.515,2.81-0.719,8.604-0.719,8.604 c5.206,34.083,15.529,114.471,7.23,178.103H160.92c0,0,1.388-110.094-11.848-145.671c-1.522,19.04-16.998,145.596-16.998,145.596 h-15.261c0,0,2.279-47.608,4.563-92.578c1.206-23.744-1.255-72.593,1.019-89.966L124.466,217.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M149.076,265.49c1.953,5.243,3.577,11.791,4.946,19.156 c1.238-16.943-3.715-34.913-3.715-34.913L149.076,265.49z"
  }), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "136.763,226.11 162.145,229.926 162.792,224.893 137.497,221.115  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.354,220.795 123.801,219.07 122.847,224.017 134.671,225.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.778,225.19 163.852,230.183 168.78,230.923 169.4,225.88  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M155.342,223.796c-0.365-0.488-0.889-0.828-1.449-0.923l-4.02-0.701 c-1.041-0.181-1.914,0.48-2.031,1.538l-0.288,2.601c-0.063,0.565,0.111,1.171,0.477,1.661c0.328,0.439,0.787,0.755,1.279,0.885 c0.058,0.015,0.115,0.027,0.174,0.038l4.021,0.692c1.039,0.179,1.91-0.482,2.027-1.538l0.287-2.593 C155.881,224.892,155.707,224.287,155.342,223.796z M153.53,228.526l-4.021-0.693c-0.276-0.046-0.524-0.206-0.704-0.447 c-0.18-0.24-0.262-0.526-0.231-0.804l0.288-2.601c0.057-0.512,0.48-0.833,0.984-0.745l4.02,0.701 c0.029,0.006,0.057,0.011,0.085,0.018c0.24,0.063,0.456,0.214,0.617,0.429c0.179,0.24,0.261,0.526,0.23,0.804l-0.044,0.394 c-0.051-0.022-0.099-0.051-0.154-0.061l-1.125-0.207c-0.374-0.069-0.691,0.192-0.705,0.579c-0.013,0.387,0.282,0.76,0.656,0.829 l1.125,0.207c0.019,0.003,0.035-0.003,0.054-0.001l-0.094,0.854C154.455,228.292,154.033,228.612,153.53,228.526z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M161.264,168.368l1.529,7.423c0,0-3.446,18.705,1.059,36.034l4.335,2.538l2.374-3.446 c0,0-6.724-16.91-5.15-33.729l3.99-5.453L161.264,168.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M161.965,159.491l4.258,10.004l5.303-5.601l3.73,5.847c0,0-0.056,4.617-3.703,7.503l-5.505-5.534 l-8.382,0.97c0,0-2.602-8.661-2.014-10.889C156.24,159.563,161.965,159.491,161.965,159.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M133.3,187.84c2.4-7.61,4.76-14.32,6.65-19.47l2.78-1.24 C142.73,167.13,146.11,177.93,133.3,187.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M161.965,159.491l4.258,10.004l5.303-5.601l3.73,5.847 c0,0-0.056,4.617-3.703,7.503l-5.505-5.534l-8.382,0.97c0,0-2.602-8.661-2.014-10.889 C156.24,159.563,161.965,159.491,161.965,159.491z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M144.039,157.746c-5.918-0.285-17.884,13.825-20.917,16.331c-3.033,2.505-11.35,2.13-16.254-2.343 c0,0-3.754-0.757-5.374,1.816c0,0,7.977,11.399,19.233,10.158c11.257-1.24,18.58-11.974,18.58-11.974s3.133-3.195,4.732-7.283 C145.637,160.363,144.039,157.746,144.039,157.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M144.039,157.746 c-5.918-0.285-17.884,13.825-20.917,16.331c-3.033,2.505-11.35,2.13-16.254-2.343c0,0-3.754-0.757-5.374,1.816 c0,0,7.977,11.399,19.233,10.158c11.257-1.24,18.58-11.974,18.58-11.974s3.133-3.195,4.732-7.283 C145.637,160.363,144.039,157.746,144.039,157.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "246.87,298.501 247.704,300.476 245.759,299.575 238.497,292.064 239.607,290.99  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M96.255,138.345l-5.486,5.304l-14.688-15.192c-0.53-0.548-0.515-1.421,0.033-1.951l3.502-3.386 c0.548-0.53,1.421-0.515,1.951,0.033L96.255,138.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M96.255,138.345l-5.486,5.304l-14.688-15.192 c-0.53-0.548-0.515-1.421,0.033-1.951l3.502-3.386c0.548-0.53,1.421-0.515,1.951,0.033L96.255,138.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M93.684,133.696l-7.475,7.227c-1.386,1.34-1.464,3.541-0.174,4.974 c44.103,48.984,89.992,96.386,137.519,142.054l0,0c0,0,10.39,8.418,20.476,10.574l1.848-1.786 c-1.815-10.154-9.878-20.821-9.878-20.821l0,0c-44.04-49.039-89.869-96.499-137.339-142.228 C97.272,132.352,95.071,132.356,93.684,133.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.046,126.698l-12.6,12.182c-0.424,0.41-0.435,1.086-0.025,1.51l1.224,1.266l12.81-12.385 c19.349,18.213,33.929,34.872,33.929,34.872l-0.504,1.356l4.561,2.771c-3.808-8.583-32.409-36.451-37.709-41.573 C98.262,126.242,97.517,126.243,97.046,126.698z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.015,
    y: 205.263,
    transform: "matrix(0.7189 -0.6951 0.6951 0.7189 -99.7893 167.8255)",
    style: {
      fill: "#407BFF"
    },
    width: 21.204,
    height: 4.073
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.405,240.866c13.797,13.933,27.717,27.722,41.754,41.305c0.639,0.618,1.653,0.617,2.292,0 l11.946-11.55c0.639-0.618,0.674-1.632,0.078-2.291c-13.097-14.481-26.41-28.858-39.875-43.121 c-0.63-0.667-1.685-0.691-2.344-0.053l-13.824,13.366C173.771,239.159,173.759,240.214,174.405,240.866z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.015,
    y: 205.263,
    transform: "matrix(0.7189 -0.6951 0.6951 0.7189 -99.7893 167.8255)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 21.204,
    height: 4.073
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M97.046,126.698l-12.6,12.182 c-0.424,0.41-0.435,1.086-0.025,1.51l1.224,1.266l12.81-12.385c19.349,18.213,33.929,34.872,33.929,34.872l-0.504,1.356 l4.561,2.771c-3.808-8.583-32.409-36.451-37.709-41.573C98.262,126.242,97.517,126.243,97.046,126.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M174.405,240.866 c13.797,13.933,27.717,27.722,41.754,41.305c0.639,0.618,1.653,0.617,2.292,0l11.946-11.55c0.639-0.618,0.674-1.632,0.078-2.291 c-13.097-14.481-26.41-28.858-39.875-43.121c-0.63-0.667-1.685-0.691-2.344-0.053l-13.824,13.366 C173.771,239.159,173.759,240.214,174.405,240.866z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M195.434,222.582l-1.172,1.564c0,0-1.858-0.551-3.612,0.642c0,0,0.104,3.972,0.267,4.501 c0.36,1.163,5.577,4.618,6.92,4.803c0.423,0.058,1.229-2.721,1.095-3.669c-0.141-0.998-1.785-3.615-1.785-3.615l0.98-1.395 L195.434,222.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M106.934,173.747l0.159-1.253c0,0,0.844,0.208,1.206-1.25c0.362-1.458,1.093-5.06,0.58-5.94 c-0.513-0.88-3.729-4.367-4.475-5.012c-0.746-0.645-2.473,2.399-2.859,3.813c-0.386,1.413,1.569,6.872,1.569,6.872l-0.08,2.372 C103.034,173.349,104.89,174.604,106.934,173.747z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M184.581,177.11c2.865,3.285,11.891,16.586,14.364,23.077c3.468,9.099,0,27.407,0,27.407 l-6.035-4.045c0,0,1.132-13.934-0.422-18.879c-1.555-4.945-13.706-14.241-13.706-14.241s0.246-2.77,1.821-6.48 C182.5,179.484,184.581,177.11,184.581,177.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M198.95,227.59l-6.04-4.04c0,0,1.13-13.93-0.42-18.88 c-0.88-2.8-5.17-7-8.72-10.11c-2.71-2.38-4.99-4.13-4.99-4.13s0.23-2.55,1.63-6.03c0.06-0.15,0.13-0.3,0.19-0.45 c1.9-4.47,3.98-6.84,3.98-6.84c2.87,3.28,11.89,16.59,14.37,23.08C202.41,209.29,198.95,227.59,198.95,227.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M183.77,194.56c-2.71-2.38-4.99-4.13-4.99-4.13s0.23-2.55,1.63-6.03 C181.78,186.42,183.55,189.88,183.77,194.56z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingcontracts);
export default __webpack_public_path__ + "static/media/existingcontracts.6c1c7deb.svg";
export { ForwardRef as ReactComponent };